<div class="floating-whatsapp" (click)="openWhatsApp()">
    <img src="assets/whatsapp-icon.png" alt="WhatsApp" />
  </div>
  
